import api from '../api';
import axios from 'axios';

export default {
    // Fetch the booking's email/whatsapp thread (bookingConversations), keyed by bookingId.
    GET_BY_BOOKING: (id, query) => {
        return new Promise((resolve, reject) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.bookingConversation.GET_BY_BOOKING(id, query))
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
    // Send an accommodation booking mail (FormData: see sales-feed SEND_MAIL_WITH_ATTACHMENTS).
    SEND_MAIL: (data) => {
        return new Promise((resolve, reject) => {
            axios
                .post(process.env.REACT_APP_BACKEND_URL + api.bookingConversation.SEND_MAIL(), data)
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
};
